import {BaseService} from "@/core/services/BaseService";
import {ENDPOINT} from "@/core/config/Constant";
import {buildFormData} from "@/core/helpers/functions";

class DocumentService extends BaseService<any> {
  endpoint = ENDPOINT.DOCUMENT

  async upload(data) {
    const formData = buildFormData(data)
    return await this.uploadHttp().post(this.endpoint, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      return res.data;
    })
  }

  async edit(id, data) {
    const formData = buildFormData(data)
    return await this.uploadHttp().put(this.endpoint + "/" + id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      return res.data;
    })
  }

  async download(id) {
    console.log("download is ", id)
    return await this.http().get(this.endpoint + "/" + id + "/download",
      {responseType: "blob"}).then(res => {
      return res;
    })
  }

  // Raw bytes for in-browser preview (pdf.js). Fetched through our authenticated API
  // (same origin as the app), so it avoids the S3 CORS block a direct presigned-URL
  // fetch hits.
  async inlineBytes(id): Promise<ArrayBuffer> {
    return await this.http().get(this.endpoint + "/" + id + "/inline",
      {responseType: "arraybuffer"}).then(res => res.data)
  }

  async rename(id, data) {
    return await this.http().put(this.endpoint + "/" + id + "/rename", data).then(res => {
      return res;
    })
  }

  async uploadImage(data) {
    const formData = buildFormData(data);
    return await this.uploadHttp().post(this.endpoint + "/image/upload", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(res => {
      return res.data;
    })
  }

  async uploadBase64Image(data) {
    return await this.uploadHttp().post(this.endpoint + "/image/upload-image", data).then(res => {
      return res.data;
    })
  }

  async getUrl(id) {
    return await this.http().get(this.endpoint + "/" + id + "/presign-url").then(res => {
      return res.data
    })
  }

  async getContentUrl(id) {
    return await this.http().get(this.endpoint + "/" + id + "/content-presign-url").then(res => {
      return res.data
    })
  }

  async msg(data) {
    const formData = buildFormData(data);
    return await this.uploadHttp().post(this.endpoint + "/msg", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(res => {
      return res.data;
    })
  }


  async notify(id, model) {
    return await this.http().post(this.endpoint + "/" + id + "/notify", model).then(res => {
      return res.data
    })
  }

  async confirm(id, data) {
    return await this.http().post(this.endpoint + "/" + id + "/confirm", data).then(res => {
      return res.data;
    })
  }


  async medicalReview(id) {
    return this.http().get(this.endpoint + "/" + id + "/medical-review").then(res => {
      return res.data;
    })
  }


  async uploadPhoneCall(data) {
    const formData = buildFormData(data);
    return await this.uploadHttp().post(this.endpoint + "/inbound-call", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(res => {
      return res.data;
    })
  }

  async extractAll(id, object) {
    return this.http().get(this.endpoint + "/extract-text/" + id + "/" + object).then(res => {
      return res.data;
    })
  }

  async extractInvoice(id) {
    return this.http().get(this.endpoint + "/" + id + "/extract-invoice").then(res => {
      return res.data;
    })
  }

  async checkFraud(id: any) {
    return this.http().get(this.endpoint + "/" + id + "/check-fraud").then(res => {
      return res.data
    })
  }

  async mergeCob(payload: { claimId: string; documentIds: string[] }) {
    return await this.http().post(this.endpoint + "/cob/merge", payload).then(res => {
      return res.data
    })
  }
}

export default new DocumentService();